import { Asset, Transaction, Property, NetWorthData, AIInsight, Dividend, Business, Goal, BudgetCategory, CalendarEvent, PortfolioAnalytics, Currency, DividendPortfolio, BusinessTransaction } from '../types';

export const mockAssets: Asset[] = [
  {
    id: '1',
    user_id: 'user1',
    type: 'cash',
    name: 'Checking Account',
    value: 15000,
    currency: 'USD',
    institution: 'Chase Bank',
    account_number: '****1234',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    user_id: 'user1',
    type: 'cash',
    name: 'Savings Account',
    value: 50000,
    currency: 'USD',
    institution: 'Chase Bank',
    account_number: '****5678',
    interest_rate: 0.04,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '3',
    user_id: 'user1',
    type: 'investment',
    name: '401(k)',
    value: 125000,
    currency: 'USD',
    institution: 'Fidelity',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '4',
    user_id: 'user1',
    type: 'investment',
    name: 'Brokerage Account',
    value: 75000,
    currency: 'USD',
    institution: 'Vanguard',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '5',
    user_id: 'user1',
    type: 'debt',
    name: 'Student Loan',
    value: -25000,
    currency: 'USD',
    institution: 'Sallie Mae',
    interest_rate: 0.045,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '6',
    user_id: 'user1',
    type: 'business',
    name: 'Freelance Business',
    value: 15000,
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
];

export const mockTransactions: Transaction[] = [
  {
    id: '1',
    user_id: 'user1',
    amount: 2500,
    type: 'income',
    category: 'Salary',
    description: 'Monthly salary',
    classification: 'personal',
    date: '2024-01-15',
    currency: 'USD',
    created_at: '2024-01-15T00:00:00Z',
  },
  {
    id: '2',
    user_id: 'user1',
    amount: -1200,
    type: 'expense',
    category: 'Rent',
    description: 'Monthly rent payment',
    classification: 'personal',
    date: '2024-01-01',
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '3',
    user_id: 'user1',
    amount: -300,
    type: 'expense',
    category: 'Food',
    description: 'Grocery shopping',
    classification: 'personal',
    date: '2024-01-10',
    currency: 'USD',
    created_at: '2024-01-10T00:00:00Z',
  },
  {
    id: '4',
    user_id: 'user1',
    amount: 500,
    type: 'income',
    category: 'Freelance',
    description: 'Web design project',
    classification: 'business',
    business_id: '1',
    currency: 'USD',
    date: '2024-01-12',
    created_at: '2024-01-12T00:00:00Z',
  },
  {
    id: '5',
    user_id: 'user1',
    amount: 150,
    type: 'income',
    category: 'Dividend',
    description: 'AAPL dividend payment',
    classification: 'personal',
    dividend_id: '1',
    currency: 'USD',
    date: '2024-01-20',
    created_at: '2024-01-20T00:00:00Z',
  },
];

export const mockProperties: Property[] = [
  {
    id: '1',
    user_id: 'user1',
    address: '123 Main St, City, State 12345',
    purchase_price: 300000,
    current_value: 350000,
    monthly_rent: 2500,
    annual_taxes: 6000,
    annual_expenses: 8000,
    property_type: 'residential',
    occupancy_rate: 0.95,
    mortgage_amount: 240000,
    mortgage_rate: 0.035,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    user_id: 'user1',
    address: '456 Oak Ave, City, State 12345',
    purchase_price: 200000,
    current_value: 220000,
    monthly_rent: 1800,
    annual_taxes: 4000,
    annual_expenses: 6000,
    property_type: 'residential',
    occupancy_rate: 0.98,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
];

// New dividend data
export const mockDividends: Dividend[] = [
  {
    id: '1',
    user_id: 'user1',
    stock_symbol: 'AAPL',
    stock_name: 'Apple Inc.',
    amount_per_share: 0.24,
    shares_owned: 100,
    total_amount: 24,
    ex_dividend_date: '2024-01-15',
    payment_date: '2024-01-20',
    frequency: 'quarterly',
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    user_id: 'user1',
    stock_symbol: 'MSFT',
    stock_name: 'Microsoft Corporation',
    amount_per_share: 0.75,
    shares_owned: 50,
    total_amount: 37.5,
    ex_dividend_date: '2024-01-20',
    payment_date: '2024-01-25',
    frequency: 'quarterly',
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '3',
    user_id: 'user1',
    stock_symbol: 'JNJ',
    stock_name: 'Johnson & Johnson',
    amount_per_share: 1.19,
    shares_owned: 25,
    total_amount: 29.75,
    ex_dividend_date: '2024-01-25',
    payment_date: '2024-01-30',
    frequency: 'quarterly',
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
];

export const mockDividendPortfolio: DividendPortfolio = {
  id: '1',
  user_id: 'user1',
  name: 'Dividend Growth Portfolio',
  total_value: 25000,
  annual_dividend_income: 1200,
  dividend_yield: 0.048,
  currency: 'USD',
  created_at: '2024-01-01T00:00:00Z',
  updated_at: '2024-01-01T00:00:00Z',
};

// New business data
export const mockBusinesses: Business[] = [
  {
    id: '1',
    user_id: 'user1',
    name: 'Freelance Web Design',
    type: 'sole_proprietorship',
    industry: 'Technology',
    monthly_revenue: 8000,
    monthly_expenses: 2000,
    profit_margin: 0.75,
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    user_id: 'user1',
    name: 'Rental Property Management',
    type: 'llc',
    industry: 'Real Estate',
    monthly_revenue: 4300,
    monthly_expenses: 1200,
    profit_margin: 0.72,
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
];

export const mockBusinessTransactions: BusinessTransaction[] = [
  {
    id: '1',
    user_id: 'user1',
    business_id: '1',
    amount: 5000,
    type: 'income',
    category: 'Client Payment',
    description: 'Website redesign for ABC Corp',
    date: '2024-01-15',
    currency: 'USD',
    created_at: '2024-01-15T00:00:00Z',
  },
  {
    id: '2',
    user_id: 'user1',
    business_id: '1',
    amount: -500,
    type: 'expense',
    category: 'Software',
    description: 'Adobe Creative Suite subscription',
    date: '2024-01-01',
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
  },
];

// Enhanced goals data
export const mockGoals: Goal[] = [
  {
    id: '1',
    user_id: 'user1',
    name: 'Emergency Fund',
    description: 'Save 6 months of expenses',
    target_amount: 30000,
    current_amount: 25000,
    monthly_contribution: 1000,
    target_date: '2024-06-01',
    status: 'active',
    icon: '🏦',
    color: '#10B981',
    goal_type: 'savings',
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    user_id: 'user1',
    name: 'Investment Portfolio',
    description: 'Build dividend portfolio',
    target_amount: 100000,
    current_amount: 75000,
    monthly_contribution: 2000,
    target_date: '2024-12-31',
    status: 'active',
    icon: '📈',
    color: '#3B82F6',
    goal_type: 'investment',
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '3',
    user_id: 'user1',
    name: 'Real Estate Portfolio',
    description: 'Own 5 rental properties',
    target_amount: 1500000,
    current_amount: 570000,
    monthly_contribution: 5000,
    target_date: '2028-12-31',
    status: 'active',
    icon: '🏠',
    color: '#8B5CF6',
    goal_type: 'real_estate',
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
];

// Enhanced budget categories
export const mockBudgetCategories: BudgetCategory[] = [
  {
    id: '1',
    user_id: 'user1',
    name: 'Housing',
    icon: '🏠',
    color: '#3B82F6',
    is_default: true,
    category_type: 'expense',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    user_id: 'user1',
    name: 'Food',
    icon: '🍽️',
    color: '#10B981',
    is_default: true,
    category_type: 'expense',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '3',
    user_id: 'user1',
    name: 'Transportation',
    icon: '🚗',
    color: '#F59E0B',
    is_default: true,
    category_type: 'expense',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '4',
    user_id: 'user1',
    name: 'Salary',
    icon: '💰',
    color: '#10B981',
    is_default: true,
    category_type: 'income',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '5',
    user_id: 'user1',
    name: 'Freelance',
    icon: '💼',
    color: '#8B5CF6',
    is_default: true,
    category_type: 'income',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
];

// Enhanced calendar events
export const mockCalendarEvents: CalendarEvent[] = [
  {
    id: '1',
    user_id: 'user1',
    title: 'Rent Payment',
    description: 'Monthly rent for Main St property',
    amount: 1200,
    event_date: '2024-02-01',
    event_type: 'bill',
    is_recurring: true,
    recurrence_pattern: 'monthly',
    is_completed: false,
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    user_id: 'user1',
    title: 'AAPL Dividend',
    description: 'Apple Inc. quarterly dividend',
    amount: 24,
    event_date: '2024-02-20',
    event_type: 'dividend',
    is_recurring: true,
    recurrence_pattern: 'quarterly',
    is_completed: false,
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
  {
    id: '3',
    user_id: 'user1',
    title: 'Property Tax Due',
    description: 'Annual property tax for Oak Ave',
    amount: 4000,
    event_date: '2024-03-15',
    event_type: 'bill',
    is_recurring: true,
    recurrence_pattern: 'yearly',
    is_completed: false,
    currency: 'USD',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-01T00:00:00Z',
  },
];

// Portfolio analytics
export const mockPortfolioAnalytics: PortfolioAnalytics = {
  id: '1',
  user_id: 'user1',
  total_value: 265000,
  total_return: 15000,
  total_return_percentage: 0.06,
  dividend_income: 1200,
  dividend_yield: 0.048,
  real_estate_roi: 0.085,
  business_profit: 7200,
  currency: 'USD',
  period: 'month',
  created_at: '2024-01-15T00:00:00Z',
};

// Enhanced AI insights
export const mockAIInsights: AIInsight[] = [
  {
    id: '1',
    user_id: 'user1',
    message: 'Your real estate portfolio increased by $20,000 this week due to market appreciation.',
    type: 'positive',
    category: 'real_estate',
    actionable: false,
    created_at: '2024-01-15T00:00:00Z',
  },
  {
    id: '2',
    user_id: 'user1',
    message: 'Your dividend portfolio is yielding 4.8%, which is above the market average of 3.2%.',
    type: 'positive',
    category: 'investment',
    actionable: false,
    created_at: '2024-01-14T00:00:00Z',
  },
  {
    id: '3',
    user_id: 'user1',
    message: 'Consider increasing your emergency fund to cover 6 months of expenses.',
    type: 'warning',
    category: 'budget',
    actionable: true,
    action_url: '/app/goals',
    created_at: '2024-01-13T00:00:00Z',
  },
  {
    id: '4',
    user_id: 'user1',
    message: 'Your business profit margin of 75% is excellent. Consider reinvesting profits for growth.',
    type: 'opportunity',
    category: 'business',
    actionable: true,
    action_url: '/app/business',
    created_at: '2024-01-12T00:00:00Z',
  },
];

// Multi-currency support
export const mockCurrencies: Currency[] = [
  {
    code: 'USD',
    name: 'US Dollar',
    symbol: '$',
    exchange_rate_to_usd: 1,
    last_updated: '2024-01-15T00:00:00Z',
  },
  {
    code: 'CAD',
    name: 'Canadian Dollar',
    symbol: 'C$',
    exchange_rate_to_usd: 0.75,
    last_updated: '2024-01-15T00:00:00Z',
  },
  {
    code: 'EUR',
    name: 'Euro',
    symbol: '€',
    exchange_rate_to_usd: 1.09,
    last_updated: '2024-01-15T00:00:00Z',
  },
];

export const mockNetWorthData: NetWorthData = {
  total: 265000,
  cash: 65000,
  real_estate: 570000,
  investments: 200000,
  dividends: 25000,
  business: 15000,
  debt: -25000,
  period: 'day',
  currency: 'USD',
};

// Add a type for the chart data
export type NetWorthChartDataMap = {
  hour: { date: string; value: number }[];
  day: { date: string; value: number }[];
  week: { date: string; value: number }[];
  month: { date: string; value: number }[];
  [year: string]: { date: string; value: number }[];
};

export const mockNetWorthChartData: NetWorthChartDataMap = {
  hour: [
    { date: '2024-01-15T09:00:00Z', value: 264500 },
    { date: '2024-01-15T12:00:00Z', value: 264800 },
    { date: '2024-01-15T15:00:00Z', value: 265000 },
    { date: '2024-01-15T18:00:00Z', value: 265200 },
  ],
  day: [
    { date: '2024-01-10T00:00:00Z', value: 260000 },
    { date: '2024-01-11T00:00:00Z', value: 262000 },
    { date: '2024-01-12T00:00:00Z', value: 261500 },
    { date: '2024-01-13T00:00:00Z', value: 263000 },
    { date: '2024-01-14T00:00:00Z', value: 264500 },
    { date: '2024-01-15T00:00:00Z', value: 265000 },
  ],
  week: [
    { date: '2024-01-01T00:00:00Z', value: 255000 },
    { date: '2024-01-08T00:00:00Z', value: 258000 },
    { date: '2024-01-15T00:00:00Z', value: 265000 },
  ],
  month: [
    { date: '2023-12-15T00:00:00Z', value: 250000 },
    { date: '2024-01-01T00:00:00Z', value: 255000 },
    { date: '2024-01-15T00:00:00Z', value: 265000 },
  ],
  '2025': [
    { date: '2025-01-01T00:00:00Z', value: 285000 },
    { date: '2025-06-01T00:00:00Z', value: 295000 },
    { date: '2025-12-31T00:00:00Z', value: 305000 },
  ],
  '2026': [
    { date: '2026-01-01T00:00:00Z', value: 315000 },
    { date: '2026-06-01T00:00:00Z', value: 325000 },
    { date: '2026-12-31T00:00:00Z', value: 335000 },
  ],
  '2027': [
    { date: '2027-01-01T00:00:00Z', value: 345000 },
    { date: '2027-06-01T00:00:00Z', value: 355000 },
    { date: '2027-12-31T00:00:00Z', value: 365000 },
  ],
  '2028': [
    { date: '2028-01-01T00:00:00Z', value: 375000 },
    { date: '2028-06-01T00:00:00Z', value: 385000 },
    { date: '2028-12-31T00:00:00Z', value: 395000 },
  ],
  '2029': [
    { date: '2029-01-01T00:00:00Z', value: 405000 },
    { date: '2029-06-01T00:00:00Z', value: 415000 },
    { date: '2029-12-31T00:00:00Z', value: 425000 },
  ],
}; 